"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ripples = void 0;
var _getRippleStyles = require("./getRippleStyles");
var _grey = _interopRequireDefault(require("../tokens/color/grey"));
var _white = _interopRequireDefault(require("../tokens/color/white"));
var ripples = exports.ripples = {
  dark: (0, _getRippleStyles.getRippleStyles)(_grey["default"].z300),
  light: (0, _getRippleStyles.getRippleStyles)(_white["default"])
};